/** What a spot on the backdrop is (for future stickers, sounds and statistics). */
export type SpotKind =
	| "pumpkin"
	| "window"
	| "door"
	| "skull"
	| "flower"
	| "fountain"
	| "minifig"
	| "tree";

/** A place on the backdrop where a light can switch on, in backdrop pixels. */
export interface Spot {
	name: string;
	kind: SpotKind;
	x: number;
	y: number;
	/** The light's size and, plus the tap's reach, how close a tap must be. */
	r: number;
}

/**
 * The spots of public/assets/gfx/backdrop.png (LEGO 21351, 1200×958), measured on a grid
 * overlay. A new picture needs new measurements. The order is part of the game state (spot
 * indices): append new spots instead of reordering.
 */
export const SPOTS: readonly Spot[] = [
	// Minifigures
	{ name: "Jack", kind: "minifig", x: 186, y: 392, r: 30 },
	{ name: "Sally", kind: "minifig", x: 146, y: 412, r: 28 },
	{ name: "Zero", kind: "minifig", x: 253, y: 696, r: 24 },
	{ name: "Jultomten", kind: "minifig", x: 255, y: 830, r: 40 },
	{ name: "Lock", kind: "minifig", x: 392, y: 782, r: 24 },
	{ name: "Shock", kind: "minifig", x: 452, y: 774, r: 26 },
	{ name: "Barrel", kind: "minifig", x: 524, y: 778, r: 24 },
	{ name: "Borgmästaren", kind: "minifig", x: 955, y: 706, r: 38 },
	// Pumpkins
	{ name: "Pumpa vid berget", kind: "pumpkin", x: 98, y: 700, r: 17 },
	{ name: "Liten pumpa", kind: "pumpkin", x: 118, y: 724, r: 17 },
	{ name: "Lyktgubbe", kind: "pumpkin", x: 180, y: 718, r: 22 },
	{ name: "Pumpa vid gravarna", kind: "pumpkin", x: 312, y: 706, r: 18 },
	{ name: "Pumpa vid spindeln", kind: "pumpkin", x: 424, y: 684, r: 15 },
	{ name: "Pumpa vid grinden", kind: "pumpkin", x: 670, y: 700, r: 17 },
	{ name: "Pumpa på girlangen", kind: "pumpkin", x: 861, y: 536, r: 18 },
	// Windows
	{ name: "Vindsfönster", kind: "window", x: 564, y: 233, r: 20 },
	{ name: "Gult fönster vänster", kind: "window", x: 552, y: 350, r: 17 },
	{ name: "Gult fönster höger", kind: "window", x: 590, y: 350, r: 17 },
	{ name: "Klockan", kind: "window", x: 861, y: 408, r: 27 },
	// Doors
	{ name: "Jacks dörr", kind: "door", x: 572, y: 528, r: 32 },
	{ name: "Grinden", kind: "door", x: 540, y: 662, r: 40 },
	{ name: "Rådhusets dörr", kind: "door", x: 873, y: 612, r: 34 },
	// Skull
	{ name: "Dödskallen", kind: "skull", x: 1036, y: 762, r: 16 },
	// Flowers
	{ name: "Blomma vid berget", kind: "flower", x: 75, y: 702, r: 11 },
	{ name: "Blomma framme", kind: "flower", x: 142, y: 750, r: 11 },
	{ name: "Blomma vid Zero", kind: "flower", x: 257, y: 730, r: 11 },
	{ name: "Blomma vid spindeln", kind: "flower", x: 415, y: 722, r: 11 },
	{ name: "Blomma vid fontänen", kind: "flower", x: 691, y: 708, r: 11 },
	{ name: "Blomma vid trappan", kind: "flower", x: 841, y: 686, r: 11 },
	{ name: "Blomma vid dödskallen", kind: "flower", x: 1009, y: 810, r: 11 },
	// Fountain
	{ name: "Fontänen", kind: "fountain", x: 775, y: 712, r: 36 },
	{ name: "Fontänens figur", kind: "fountain", x: 760, y: 612, r: 26 },
	// Tree
	{ name: "Höstträdet", kind: "tree", x: 395, y: 470, r: 34 },
];
